// extracted by mini-css-extract-plugin
export default {"container":"SearchInput-module--container--cA3jA","search":"SearchInput-module--search--ReCxB"};